import React from "react";
import { useState } from "react";
import SuccessModal from "../shared/SuccessModal";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";

const CAB_FAIR_ENDPOINT = "https://script.google.com/macros/s/AKfycbyRi_dF5J-nMEwMst83kfs7lEEXZJTr-rQz_UPnmNq2ptfs-cuIL8vjcTsRGx3Oo0NNOA/exec";

const CabFair = () => {
  const [netID, setNetID] = useState("");
  const [showModal, setShowModal] = useState(0);

  const appendNetID = async () => {
    const cleanedNetID = netID.trim();

    if (!cleanedNetID) return;

    setShowModal(1);

    try {
      const response = await fetch(CAB_FAIR_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain;charset=utf-8",
        },
        body: JSON.stringify({
          netID: cleanedNetID,
        }),
      });

      const data = await response.json();

      if (data.success) {
        setShowModal(2);
      } else {
        setShowModal(3);
      }
    } catch (error) {
      console.error("Error submitting NetID:", error);
      setShowModal(3);
    }
  };

  const closeModal = () => {
    setShowModal(0);
    setNetID("");
  };

  return (
    <div className="cab-fair">
      <AnimationOnScroll animateIn="animate__fadeIn" delay={300}>
        <img
          src="/logo-white.png"
          alt="Hoyalytics"
          className="cab-logo"
        />
      </AnimationOnScroll>

      <AnimationOnScroll animateIn="animate__fadeIn" delay={300}>
        <h3 className="cab-subtitle">
          Interested in joining Hoyalytics? Type your NetID below and press Enter!
        </h3>
      </AnimationOnScroll>

      <form
        className="cab-input"
        onSubmit={(e) => {
          e.preventDefault();

          if (showModal === 0) {
            appendNetID();
          }
        }}
      >
        <input
          type="text"
          value={netID}
          placeholder="Your NetID"
          onChange={(e) => setNetID(e.target.value)}
          autoComplete="off"
          autoFocus
        />
      </form>

      {showModal !== 0 && (
        <SuccessModal
          closeModal={closeModal}
          netID={netID}
          status={showModal}
        />
      )}
    </div>
  );
};

export default CabFair;
